import * as React from 'react';
import { Helmet } from 'react-helmet';
import ReactInputMask from 'react-input-mask';
import fac from 'assets/images/Powered-by-FAC_web.jpg';
import master from 'assets/images/vbv_mcsc_logo.gif';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

const SslSealBadge: React.FunctionComponent<Props> = () => {
  return (
    <>
      <Helmet>
        <script
          async
          type="text/javascript"
          src="https://seal.godaddy.com/getSeal?sealID=zDPC8te3u1UPit3pZwUiSVvtaETJ7pYn4o67YdppGUiBhTev6aXhHWXiisDX"
        />
      </Helmet>
      <img style={{ height: 32 }} src={master} />
      <img style={{ height: 32 }} src={fac} />
      <img
        style={{ cursor: 'pointer' }}
        src="https://seal.godaddy.com/images/3/en/siteseal_gd_3_h_l_m.gif"
        onClick={x => eval('verifySeal()')}
        alt="SSL site seal - click to verify"
      />
    </>
  );
};

export default React.memo(SslSealBadge, () => true);
